export interface DividerProps {}
